import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper/core";

const Heros = () => {
  SwiperCore.use([Autoplay, Pagination, Navigation]);
  return (
    <>
      <div className="hero">
        <Swiper
          slidesPerView={1}
          spaceBetween={30}
          loop={true}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation={true}
          className="mySwiper"
        >
          <SwiperSlide><img src="https://res.cloudinary.com/kurier247/image/upload/v1620733605/test/jof3knxhsy2tquuxgjhz.jpg" alt="" /></SwiperSlide>
          <SwiperSlide><img src="https://res.cloudinary.com/kurier247/image/upload/v1620733604/test/isnbzsue9qr5vjebqc02.jpg" alt="" /></SwiperSlide>
          <SwiperSlide><img src="https://res.cloudinary.com/kurier247/image/upload/v1620733604/test/u31lhv67uoosanenuaap.jpg" alt="" /></SwiperSlide>
          <SwiperSlide><img src="https://res.cloudinary.com/kurier247/image/upload/v1620733604/test/isnbzsue9qr5vjebqc02.jpg" alt="" /></SwiperSlide>
        </Swiper>
      </div>
    </>
  );
};

export default Heros;
